import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import useInput from "src/Hooks/useInput";
import { ProfileSetupTypes } from "./data-types.local";
import ProfileSetupPresenter from "./ProfileSetupPresenter";

interface IProps extends ProfileSetupTypes, RouteComponentProps<any> {}
const ProfileSetup: React.SFC<IProps> = ({
  userInfo,
  refetch,
  match,
  country,
}) => {
  const uplineUsername = useInput(match.params.username || "");
  const name = useInput(userInfo?.name || "");
  const username = useInput(userInfo?.username || "");
  const secretKey = useInput(userInfo?.secret_key || "");

  return (
    <ProfileSetupPresenter
      uplineUsername={uplineUsername}
      name={name}
      country={country}
      username={username}
      secretKey={secretKey}
      userInfo={userInfo}
      refetch={refetch}
    />
  );
};

export default withRouter(ProfileSetup);
